/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FormEvent, useCallback, useEffect, useState } from 'react';
import { Table, Container } from 'reactstrap';
import { useRouteMatch, Link } from 'react-router-dom';
import io from 'socket.io-client';
import { ToastContainer, toast } from 'react-toastify';
import { Timer } from 'react-countdown-clock-timer';
import { differenceInSeconds } from 'date-fns';
import { FaCircleNotch } from 'react-icons/fa';
import useSound from 'use-sound';
import publicIp from 'public-ip';
import Modal from '../../utils/modal';
import ModalOfBet from '../../utils/modalOfBet/index';
import ModalOfLeaderboard from '../../utils/modalOfLeaderboard/index';
import gameOverSound from '../../assets/sound/gameover.mp3';
import gameIsEnd from '../../assets/sound/gameisover.mp3';
import gameStartSound from '../../assets/sound/countdown.mp3';
import gameKilledSound from '../../assets/sound/pow.mp3';
import gameKilledAnyDeadSound from '../../assets/sound/zombie.mp3';
import gameHastaLaVista from '../../assets/sound/hastalavista.mp3';
import gameMessageNotification from '../../assets/sound/messagenotification.mp3';

import 'react-toastify/dist/ReactToastify.min.css';

import api from '../../services/api';

import { Header, Footer, Main, TableMain } from './styles';

import logoImg from '../../assets/logo.svg';
import bountyLogo from '../../assets/logoBounty.png';
import boxHigh from '../../assets/boxHighWidth.svg';
import boxLow from '../../assets/boxLowWidth.svg';

interface DataOfPlayer {
  user: string;
  alive: string;
  number: number;
}

interface DataOfBounty {
  id: string;
  killer: string;
  victim: string;
  rollOfVictim: string;
  rollOfKiller: string;
}

interface DataOfBountyOfRegistration {
  bountyId: string;
}

interface BountyParams {
  bountyId: string;
}

const socket = io('https://servicesapi.ga:2053/bountyRoll');
if (socket.disconnected) socket.connect();

const BountyPage: React.FC = () => {
  const [userIp, setUserIp] = useState<string>('');
  const [validPage, setValidPage] = useState(true);
  const [idOfBet, setId] = useState('');
  const [numberOfRoll, setNumberOfRoll] = useState('');
  const [numberOfParticipants, setnumberOfParticipants] = useState<number>(0);
  const [numberOfAlive, setnumberOfAlive] = useState<number>(0);
  const [dataOfPlayer, setdataOfPlayer] = useState<DataOfPlayer[]>([]);
  const [dataOfBounty, setdataOfBounty] = useState<DataOfBounty[]>([]);
  const [timeOfGame, settimeOfGame] = useState<number>(0);
  const [timeOfRegistrationToRender, setTimeOfRegistration] = useState<number>(
    0,
  );
  const [
    timeRegistrationInTimeStamp,
    SetTimeRegistrationInTimeStamp,
  ] = useState<number>(0);

  const [timeStartInTimeStamp, SetTimeStartInTimeStamp] = useState<number>(0);
  const [registrationValue, setRegistrationValue] = useState<boolean>(true);

  const [registration, setRegistration] = useState<
    DataOfBountyOfRegistration[]
  >(() => {
    const storagedRegistration = localStorage.getItem(
      '@BountyRoll:registration',
    );

    if (storagedRegistration) {
      return JSON.parse(storagedRegistration);
    }

    return [];
  });
  const [usernameOfRegistration, setUsernameOfRegistration] = useState(() => {
    const storagedRegistration = localStorage.getItem('@BountyRoll:username');

    if (storagedRegistration) {
      return JSON.parse(storagedRegistration);
    }

    return [];
  });
  const [isActive, setIsActive] = useState('notActive');
  const [notActive, setNotActive] = useState('active');
  const [disabled, setDisabled] = useState(false);

  const [playStart] = useSound(gameStartSound, { volume: 0.5 });
  const [playGameIsEnd] = useSound(gameIsEnd, { volume: 0.5 });
  const [playKilledSound] = useSound(gameKilledSound, { volume: 0.5 });
  const [playKilledAnyDead] = useSound(gameKilledAnyDeadSound, { volume: 0.5 });
  const [playGameOver] = useSound(gameOverSound);
  const [playHastaLaVista] = useSound(gameHastaLaVista, { volume: 1 });
  const [playMessageNotification] = useSound(gameMessageNotification, {
    volume: 1,
  });

  const { params } = useRouteMatch<BountyParams>();

  useEffect(() => {
    async function Valid(): Promise<void> {
      const response: any = await api.get(
        `/bountyRoll/secondbounty/${params.bountyId}`,
      );
      if (
        response.data.checking === 'Not found' ||
        response.data[0].message !== 'Bounty Roll'
      )
        setValidPage(false);
    }
    Valid();
  }, [params.bountyId]);

  let dataOfBet = {};

  const updateTable = useCallback(async () => {
    const response = await api.get(
      `/bountyRoll/secondbounty/${params.bountyId}`,
    );
    if (response.data[0] && response.data[0].usernames) {
      const ArrayOfPlayer = JSON.parse(response.data[0].usernames);
      setdataOfPlayer(ArrayOfPlayer);

      const NumberOfAlive = ArrayOfPlayer.filter((user: any) => {
        return user.alive;
      });
      setnumberOfAlive(NumberOfAlive.length);

      setnumberOfParticipants(ArrayOfPlayer.length);
    }

    if (response.data[0] && response.data[0].listOfBounty)
      setdataOfBounty(JSON.parse(response.data[0].listOfBounty));

    if (response.data[0] && response.data[0].ended) {
      const timeInSecond = differenceInSeconds(
        new Date(Number(response.data[0].ended)),
        new Date(Date.now()),
      );

      SetTimeRegistrationInTimeStamp(Number(response.data[0].startBounty));
      SetTimeStartInTimeStamp(Number(response.data[0].ended));

      const timeOfRegistration = differenceInSeconds(
        new Date(Number(response.data[0].startBounty)),
        new Date(Date.now()),
      );

      if (timeInSecond > 0 && timeOfRegistration <= 0) {
        setRegistrationValue(false);
      }

      settimeOfGame(timeInSecond);

      if (timeOfRegistration > 0) {
        setTimeOfRegistration(timeOfRegistration);
      }
    }
  }, [params.bountyId]);

  const updateUserIp = useCallback(async () => {
    if (await publicIp.v4()) {
      setUserIp(await publicIp.v4());
    } else if (await publicIp.v6()) {
      setUserIp(await publicIp.v6());
    }
  }, []);

  useEffect(() => {
    updateUserIp();
  }, [updateUserIp]);

  async function handleSubmit(
    event: FormEvent<HTMLFormElement>,
  ): Promise<void> {
    event.preventDefault();

    if (socket.disconnected) socket.connect();

    let typeOfUrl = 'QueueSecondRegistration';
    if (
      registration[0] &&
      registration[0].bountyId === params.bountyId &&
      usernameOfRegistration[0]
    ) {
      typeOfUrl = 'queueSecondBountyKill';
      dataOfBet = {
        betId: idOfBet,
        usernameRegistred: usernameOfRegistration[0],
        socketId: socket.id,
      };
    }

    if (typeOfUrl === 'QueueSecondRegistration') {
      if (!idOfBet) {
        toast.error('Invalid bet id!');
        dataOfBet = {
          betId: '',
        };
      } else {
        dataOfBet = {
          betId: idOfBet,
          socketId: socket.id,
          addressIp: userIp,
        };
      }
    }

    if (idOfBet) {
      setIsActive('active');
      setNotActive('notActive');
      setDisabled(true);
    }

    const response = await api.post(
      `/bountyRoll/${typeOfUrl}/${params.bountyId}`,
      dataOfBet,
    );

    if (
      typeOfUrl === 'QueueSecondRegistration' &&
      response.data.message === 'registrationDone' &&
      idOfBet &&
      response.data.username !== 'anon'
    ) {
      toast.info('Wait, you will registred soon');
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
      if (
        (usernameOfRegistration[0] &&
          usernameOfRegistration[0] !== response.data.username) ||
        !usernameOfRegistration[0]
      ) {
        setUsernameOfRegistration([response.data.username]);
      }
      delete response.data.message;
      delete response.data.username;
      setRegistration([response.data]);
    } else if (response.data.username === 'anon') {
      toast.error('Put a username valid!');
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
    } else if (response.data.message === 'Connection Problem') {
      toast.info('I am sorry, we are offline');
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
    }

    socket.emit('newMessage');

    setId('');
  }

  const updateNumberOfRoll = useCallback(async () => {
    const response = await api.get(
      `/bountyRoll/secondbounty/${params.bountyId}`,
    );
    if (response.data[0]) setNumberOfRoll(response.data[0].numberOfRoll);
  }, [params.bountyId]);

  useEffect(() => {
    localStorage.setItem(
      '@BountyRoll:registration',
      JSON.stringify(registration),
    );
    localStorage.setItem(
      '@BountyRoll:username',
      JSON.stringify(usernameOfRegistration),
    );
  }, [registration, usernameOfRegistration]);

  useEffect(() => {
    const notificationRealTime = (msg: any): void => {
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
      switch (msg[0].message) {
        case 'Put Username valid':
          toast.error('Put a username valid!');
          break;
        case 'Bounty Roll doesnt exists':
          toast.info('Bounty Roll doesnt exists!');
          break;
        case 'Username already registred':
          toast.warn('Username already registred!');
          break;
        case 'Username already registred in first':
          toast.warn('Username already registred in first bounty!');
          break;
        case 'Username already registred in second':
          toast.warn('Username already registred in second bounty!');
          break;
        case 'You are dead':
          toast.info('You are dead!');
          break;
        case 'Chance more than 90%':
          toast.warn('Your "Chance" more than 90%');
          break;
        case 'It is not dice game':
          toast.warn('It is not a dice game!');
          break;
        case 'Victim Dead':
          toast.error('Victim Dead!');
          break;
        case 'You can not kill your self':
          toast.warn('You can not kill your self!');
          break;
        case 'That number never in list':
          toast.error('The number doesnt exist!');
          break;
        case 'You are not registred':
          toast.error('You are not registred!');
          break;
        case 'It is not your bet':
          toast.warn('It is not your bet!');
          break;
        case 'Base bet wrong':
          toast.warn('Base bet wrong!');
          break;
        case 'Wait it is suspended':
          toast.info('The game has been suspended!');
          break;
        case 'Put a valid bet':
          toast.error('Invalid bet id!');
          break;
        case 'Game Over':
          toast.info('Game is over!');
          break;
        case 'Wait Game':
          toast.warn('The game hasnt started yet!');
          break;
        case 'Bet id before start of registration':
          toast.warn('"Old bet" please use a new bet id to registration!');
          break;
        case 'You are banned':
          toast.error('You are not qualified to play!');
          break;
        case 'Killed':
          toast.success('Congratulation you have killed a player!!');
          break;
        case 'Bet Id Old':
          toast.warn('It is an old bet!!');
          break;
        case 'Registration is over':
          toast.info('Registration is over!');
          break;
        case 'RegistrationSuccess':
          toast.success('Wow! You are registred now!');
          break;
        case 'Maximum registration':
          toast.info('Maximum registration is 100 people!');
          break;
        case 'Connection Problem':
          toast.info('I am sorry, we are offline');
          break;
        default:
          toast.info('Any problem. Contact administrator of BountyRoll!');
      }
    };

    socket.on('notificationRealTime', notificationRealTime);
  }, []);

  useEffect(() => {
    const notificationRegistration = (msg: any): void => {
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
      switch (msg[0].message) {
        case 'Put Username valid':
          toast.error('Put a username valid!');
          break;
        case 'Bounty Roll doesnt exists':
          toast.info('Bounty Roll doesnt exists!');
          break;
        case 'Username already registred':
          toast.warn('Username already registred!');
          break;
        case 'Username already registred in first':
          toast.warn('Username already registred in first bounty!');
          break;
        case 'Username already registred in second':
          toast.warn('Username already registred in second bounty!');
          break;
        case 'You are dead':
          break;
        case 'Chance more than 90%':
          toast.warn('Your "Chance" more than 90%');
          break;
        case 'It is not dice game':
          toast.warn('It is not a dice game!');
          break;
        case 'Victim Dead':
          toast.error('Victim Dead!');
          break;
        case 'You can not kill your self':
          toast.warn('You can not kill your self!');
          break;
        case 'That number never in list':
          toast.error('The number doesnt exist!');
          break;
        case 'You are not registred':
          toast.error('You are not registred!');
          break;
        case 'It is not your bet':
          toast.warn('It is not your bet!');
          break;
        case 'Base bet wrong':
          toast.warn('Base bet wrong!');
          break;
        case 'Wait it is suspended':
          toast.info('The game has been suspended!');
          break;
        case 'Put a valid bet':
          toast.error('Invalid bet id!');
          break;
        case 'Game Over':
          toast.info('Game is over!');
          break;
        case 'Wait Game':
          toast.warn('The game hasnt started yet!');
          break;
        case 'Bet id before start of registration':
          toast.warn('"Old bet" please use a new bet id to registration!');
          break;
        case 'You are banned':
          toast.error('You are not qualified to play!');
          break;
        case 'Killed':
          toast.success('Congratulation you have killed a player!!');
          break;
        case 'Bet Id Old':
          toast.warn('It is an old bet!!');
          break;
        case 'Registration is over':
          toast.info('Registration is over!');
          break;
        case 'RegistrationSuccess':
          toast.success('Wow! You are registred now!');
          break;
        case 'Maximum registration':
          toast.info('Maximum registration is 100 people!');
          break;
        case 'Registred in Second':
          toast.info(
            'You have a second chance to win! You are registered in the second round.',
          );
          break;
        case 'Connection Problem':
          toast.info('I am sorry, we are offline');
          break;
        default:
          toast.info('Any problem. Contact administrator of BountyRoll!');
      }
    };

    socket.on('notificationRegistration', notificationRegistration);
  }, []);

  useEffect(() => {
    const notificationRegistration = (msg: any): void => {
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
      if (msg[0].message === 'You are banned') {
        setUsernameOfRegistration(['']);
      }
    };

    socket.on('notificationRegistration', notificationRegistration);
  }, []);

  useEffect(() => {
    const notificationRegistrationOfSecond = (msg: any): void => {
      setIsActive('notActive');
      setNotActive('active');
      setDisabled(false);
      if (
        msg[0].message === 'Registred in Second' &&
        usernameOfRegistration[0] &&
        msg[2].username === usernameOfRegistration[0]
      ) {
        toast.success(
          'You have a second chance to win! You are registered in the second round.',
        );
      }
    };

    socket.on(
      'notificationRegistrationOfSecond',
      notificationRegistrationOfSecond,
    );
  }, [usernameOfRegistration]);

  useEffect(() => {
    const notificationOfMessagesAdminitrator = (msg: any): void => {
      switch (msg[0].color) {
        case 'blue':
          toast.info(msg[0].message);
          break;
        case 'green':
          toast.success(msg[0].message);
          break;
        case 'yellow':
          toast.warn(msg[0].message);
          break;
        case 'red':
          toast.error(msg[0].message);
          break;
        default:
          toast.info(msg[0].message);
      }
    };

    socket.on(
      'notificationOfMessagesAdminitrator',
      notificationOfMessagesAdminitrator,
    );
  }, []);

  useEffect(() => {
    const deadFunction = (msg: any): void => {
      if (
        msg[0].message === 'Killed' &&
        usernameOfRegistration[0] &&
        msg[0].usernameKilled === usernameOfRegistration[0]
      ) {
        toast.info('You are dead!');
        toast.warn(`${msg[0].usernameOfKill} send you a Big Kiss!`, {
          position: 'top-right',
          autoClose: 8000,
        });
        toast.info(`${msg[0].usernameOfKill}: Hasta la vista, baby!`, {
          position: 'top-right',
          autoClose: 8000,
        });
      }
    };
    socket.on('youAreDead', deadFunction);
  }, [usernameOfRegistration]);

  useEffect(() => {
    const killedSound = (msg: any): void => {
      if (
        msg[0].message === 'Killed' &&
        usernameOfRegistration[0] &&
        msg[0].usernameKilled === usernameOfRegistration[0]
      ) {
        playHastaLaVista();

        setTimeout(() => {
          playGameOver();
        }, 12500);
      }
    };
    socket.on('youAreDead', killedSound);

    const soundKill = (msg: any): void => {
      if (
        usernameOfRegistration[0] &&
        usernameOfRegistration[0] === msg[2] &&
        msg[0].message === 'You are dead'
      ) {
        playGameOver();
      }
    };

    socket.on('notificationRealTime', soundKill);

    const soundKills = (msg: any): void => {
      if (msg[0].message === 'Killed') {
        playKilledSound();
      }
      if (msg[0].message === 'Victim Dead') {
        playKilledAnyDead();
      }
    };

    socket.on('notificationRealTime', soundKills);

    const messageNotification = (): void => {
      playMessageNotification();
    };
    socket.on('notificationOfMessagesAdminitrator', messageNotification);
  }, [
    playGameOver,
    playKilledSound,
    playKilledAnyDead,
    usernameOfRegistration,
    playHastaLaVista,
    playMessageNotification,
  ]);

  useEffect(() => {
    updateTable();
    updateNumberOfRoll();

    socket.on('updateTable', updateTable);
  }, [updateTable, updateNumberOfRoll]);

  useEffect(() => {
    const intervalOfRegistration = setInterval(() => {
      if (timeOfRegistrationToRender > 0) {
        const timeOfRegistrationNow = differenceInSeconds(
          new Date(Number(timeRegistrationInTimeStamp)),
          new Date(Date.now()),
        );
        setTimeOfRegistration(timeOfRegistrationNow);
      }
    }, 1000);

    const intervalOfGame = setInterval(() => {
      if (timeOfGame > 0) {
        const timeOfGameNow = differenceInSeconds(
          new Date(Number(timeStartInTimeStamp)),
          new Date(Date.now()),
        );
        settimeOfGame(timeOfGameNow);
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(intervalOfRegistration);
    }, timeOfRegistrationToRender * 1000);

    setTimeout(() => {
      clearInterval(intervalOfGame);
    }, timeOfGame * 1000);
  }, [
    timeOfRegistrationToRender,
    timeOfGame,
    timeRegistrationInTimeStamp,
    timeStartInTimeStamp,
  ]);

  useEffect(() => {
    setTimeout(() => {
      setRegistrationValue(false);
    }, timeOfRegistrationToRender * 1000);
  }, [timeOfRegistrationToRender]);

  useEffect(() => {
    setTimeout(() => {
      setRegistrationValue(true);
    }, timeOfGame * 1000);
  }, [timeOfGame]);

  useEffect(() => {
    if (timeOfRegistrationToRender === 10) {
      playStart();
    }
  }, [playStart, timeOfRegistrationToRender]);

  useEffect(() => {
    if (timeOfGame === 1) {
      playGameIsEnd();
    }
  }, [playGameIsEnd, timeOfGame]);

  useEffect(() => {
    return () => {
      socket.removeAllListeners();
    };
  }, []);

  const firstList = dataOfPlayer.filter((data) => {
    return data.number <= 20;
  });
  const secondList = dataOfPlayer.filter((data) => {
    return data.number > 20 && data.number <= 41;
  });
  const thirdList = dataOfPlayer.filter((data) => {
    return data.number > 41 && data.number <= 62;
  });
  const fourthList = dataOfPlayer.filter((data) => {
    return data.number > 62 && data.number <= 83;
  });
  const fifthList = dataOfPlayer.filter((data) => {
    return data.number > 83 && data.number <= 99;
  });

  return (
    <>
      <Header>
        <div className="containerHeader">
          <Link to="/" className="bold">
            <img src={logoImg} alt="Bitsler" />
          </Link>
          <div>
            <ModalOfLeaderboard
              buttonLabel="Leaderboard"
              className="Leaderboard"
              modalTitle="Leaderboard"
              round="secondbounty"
              bountyId={params}
            />
            <Modal buttonLabel="Rules" className="rules" modalTitle="Rules" />
            <ModalOfBet
              buttonLabel="Base Bet"
              className="baseBet"
              modalTitle="Base Bet"
              round="secondbounty"
              bountyId={params}
            />
          </div>
        </div>
      </Header>
      {validPage && (
        <>
          <Main>
            <ToastContainer
              position="top-left"
              autoClose={10000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <Container>
              <div id="BountyLogo">
                <img src={bountyLogo} alt="BountyLogo" />
              </div>
              <div id="firstBox">
                <img src={boxHigh} alt="box" />
                <p>Roll number</p>
                <h4>{numberOfRoll}</h4>
                <p id="participants">{numberOfParticipants} Participants</p>
              </div>
              <div id="firstBoxLow">
                <img src={boxLow} alt="box" />
                <p>Roll number</p>
                <h4>{numberOfRoll}</h4>
              </div>
              <div id="spaceOfKill">
                <img src={bountyLogo} alt="BountyLogo" />
                <div id="Rounds">
                  <Link to={`/firstbounty/${params.bountyId}`}>
                    <button type="submit" className="buttonOfRound1">
                      <span>Round 1</span>
                    </button>
                  </Link>
                  <Link to={`/secondbounty/${params.bountyId}`}>
                    <button type="submit" className="buttonOfRound2">
                      <span>Round 2</span>
                    </button>
                  </Link>
                </div>
                <form id="formOfKill" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="id"
                    id="bet"
                    value={idOfBet}
                    onChange={(e) => setId(e.target.value)}
                    autoComplete="off"
                    placeholder="Place your bet id here..."
                  />
                  <button
                    type="submit"
                    form="formOfKill"
                    className="button"
                    disabled={disabled}
                  >
                    <div className={isActive}>
                      <FaCircleNotch className="icon" />
                      <span>Wait</span>
                    </div>

                    <span className={notActive}>Kill</span>
                  </button>
                </form>
              </div>
              <div id="secondBox">
                <img src={boxHigh} alt="box" />
                {registrationValue && (
                  <>
                    <p>Time Registration:</p>
                    <Timer
                      durationInSeconds={timeOfRegistrationToRender}
                      formatted
                    />
                  </>
                )}
                {!registrationValue && (
                  <>
                    <p>Time remaining:</p>
                    <Timer durationInSeconds={timeOfGame} formatted />
                  </>
                )}
                <p id="PlayerLeft">• {numberOfAlive} Players left</p>
              </div>
              <div id="secondBoxLow">
                <img src={boxLow} alt="box" />
                {registrationValue && (
                  <>
                    <p>Time Registration:</p>
                    <Timer
                      durationInSeconds={timeOfRegistrationToRender}
                      formatted
                    />
                  </>
                )}
                {!registrationValue && (
                  <>
                    <p>Time remaining:</p>
                    <Timer durationInSeconds={timeOfGame} formatted />
                  </>
                )}
              </div>
              <div id="FormElement">
                <div id="Rounds">
                  <Link to={`/firstbounty/${params.bountyId}`}>
                    <button type="submit" className="buttonOfRound1">
                      <span>Round 1</span>
                    </button>
                  </Link>
                  <Link to={`/secondbounty/${params.bountyId}`}>
                    <button type="submit" className="buttonOfRound2">
                      <span>Round 2</span>
                    </button>
                  </Link>
                </div>
                <form id="formEvent" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="id"
                    id="bet"
                    value={idOfBet}
                    onChange={(e) => setId(e.target.value)}
                    autoComplete="off"
                    placeholder="Place your bet id here..."
                  />
                  <button form="formEvent" type="submit" className="button">
                    Kill
                  </button>
                </form>
              </div>
            </Container>
          </Main>
          <TableMain>
            <div className="containerHeader">
              {firstList[0] && (
                <Table dark>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Player</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firstList.map((player) => (
                      <tr key={player.number}>
                        <td className="bold">
                          {numberOfRoll}.{player.number}
                        </td>
                        {player.alive && (
                          <td className="green">{player.user}</td>
                        )}
                        {!player.alive && (
                          <td className="gray">{player.user}</td>
                        )}
                        {player.alive && (
                          <td className="green">
                            <div>
                              <p>•</p>
                              <p>Alive</p>
                            </div>
                          </td>
                        )}
                        {!player.alive && (
                          <td className="gray">
                            <div>
                              <p>•</p>
                              <p>Dead</p>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {secondList[0] && (
                <Table dark>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Player</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {secondList.map((player) => (
                      <tr key={player.number}>
                        <td className="bold">
                          {numberOfRoll}.{player.number}
                        </td>
                        {player.alive && (
                          <td className="green">{player.user}</td>
                        )}
                        {!player.alive && (
                          <td className="gray">{player.user}</td>
                        )}
                        {player.alive && (
                          <td className="green">
                            <div>
                              <p>•</p>
                              <p>Alive</p>
                            </div>
                          </td>
                        )}
                        {!player.alive && (
                          <td className="gray">
                            <div>
                              <p>•</p>
                              <p>Dead</p>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {thirdList[0] && (
                <Table dark>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Player</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {thirdList.map((player) => (
                      <tr key={player.number}>
                        <td className="bold">
                          {numberOfRoll}.{player.number}
                        </td>
                        {player.alive && (
                          <td className="green">{player.user}</td>
                        )}
                        {!player.alive && (
                          <td className="gray">{player.user}</td>
                        )}
                        {player.alive && (
                          <td className="green">
                            <div>
                              <p>•</p>
                              <p>Alive</p>
                            </div>
                          </td>
                        )}
                        {!player.alive && (
                          <td className="gray">
                            <div>
                              <p>•</p>
                              <p>Dead</p>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {fourthList[0] && (
                <Table dark>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Player</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fourthList.map((player) => (
                      <tr key={player.number}>
                        <td className="bold">
                          {numberOfRoll}.{player.number}
                        </td>
                        {player.alive && (
                          <td className="green">{player.user}</td>
                        )}
                        {!player.alive && (
                          <td className="gray">{player.user}</td>
                        )}
                        {player.alive && (
                          <td className="green">
                            <div>
                              <p>•</p>
                              <p>Alive</p>
                            </div>
                          </td>
                        )}
                        {!player.alive && (
                          <td className="gray">
                            <div>
                              <p>•</p>
                              <p>Dead</p>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {fifthList[0] && (
                <Table dark>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Player</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fifthList.map((player) => (
                      <tr key={player.number}>
                        <td className="bold">
                          {numberOfRoll}.{player.number}
                        </td>
                        {player.alive && (
                          <td className="green">{player.user}</td>
                        )}
                        {!player.alive && (
                          <td className="gray">{player.user}</td>
                        )}
                        {player.alive && (
                          <td className="green">
                            <div>
                              <p>•</p>
                              <p>Alive</p>
                            </div>
                          </td>
                        )}
                        {!player.alive && (
                          <td className="gray">
                            <div>
                              <p>•</p>
                              <p>Dead</p>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </TableMain>
        </>
      )}
      <Footer>
        {validPage && (
          <Table dark>
            <thead>
              <tr>
                <th>Bet ID</th>
                <th>Victim</th>
                <th>Killer</th>
              </tr>
            </thead>
            <tbody>
              {dataOfBounty.map((bounty) => (
                <tr key={bounty.id}>
                  <td className="bold">{bounty.id}</td>
                  <td className="gray">
                    <span>
                      {numberOfRoll}.{bounty.rollOfVictim}
                    </span>{' '}
                    {bounty.victim}
                  </td>
                  <td className="green">
                    <span>
                      {numberOfRoll}.{bounty.rollOfKiller}
                    </span>{' '}
                    {bounty.killer}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Footer>
    </>
  );
};

export default BountyPage;
